import React from 'react';
import './Socials.css';
import { SiLinkedin } from 'react-icons/si';
import { SiGithub } from 'react-icons/si';
import { SiInstagram } from 'react-icons/si';
import { SiWhatsapp } from 'react-icons/si';
import { HiOutlineMail } from 'react-icons/hi';

function Socials() {
  return (
    <section className="socials-container">
        <div className="line"></div>

          <div className="icons-container">
          <a href="mailto:pedrosantana.dev@gmail.com" target="_blank" rel="noreferrer">
            <HiOutlineMail className="icon"/>
          </a>

          <a href="https://www.linkedin.com/in/pedro-santana-dev/" target="_blank" rel="noreferrer">
            <SiLinkedin className="social-icon"/>
          </a>

          <a href="https://github.com/santanap2" target="_blank" rel="noreferrer">
            <SiGithub className="social-icon"/>
          </a>

          <a href="https://api.whatsapp.com/send?phone=5531998695219" target="_blank" rel="noreferrer">
            <SiWhatsapp className="social-icon"/>
          </a>
          
          <a href="https://www.instagram.com/santanap2/" target="_blank" rel="noreferrer">
            <SiInstagram className="social-icon"/>
          </a>       
          </div>
          <div className="line"></div>
        </section>
  )
}

export default  Socials;
